module.exports = __webpack_public_path__ + "static/media/team_04.442881b2.jpg";